import $, { data } from 'jquery';

class caruselGallery{
    constructor() {
        this.dots = $('.dots');
        this.carusel = $('.carusel-img');
        this.title = $('.carusel-title');
        this.galleryTitles = caruselData.photoTitles;
        this.galleryUrls = caruselData.photoUrls;
        this.setupPhoto();
    }

    setupPhoto() {
        let counter = 0;

        for( let i=0; i<this.galleryTitles.length; i++) {
            this.dots.append('<i class="fa-solid fa-circle-dot"></i>');
            this.carusel.append('<li class="slide"><img src="' + this.galleryUrls[i] +'"/></li>');
        }

        const dotsElements = this.dots.find('i');
        const imgElements = this.carusel.find('.slide');

        imgElements[0].dataset.active = true;
        dotsElements[0].dataset.active = true;
        

        let index = 0;

        this.title.text(this.galleryTitles[index]);
        console.log(this.title);

        setInterval(() => {
            if(index >= this.galleryUrls.length - 1) {
                imgElements[0].dataset.active = true;
                delete imgElements[this.galleryUrls.length - 1].dataset.active;

                setTimeout(() => {
                    dotsElements[0].dataset.active = true;
                    delete dotsElements[this.galleryUrls.length - 1].dataset.active;
                    this.title.text(this.galleryTitles[0]);
                }, 500)

                
                index = 0;
            } else {
                index++;
                console.log[index];
                imgElements[index].dataset.active = true;
                delete imgElements[index - 1].dataset.active;

                setTimeout(() => {
                    dotsElements[index].dataset.active = true;
                    delete dotsElements[index - 1].dataset.active;
                    this.title.text(this.galleryTitles[index]);
                }, 500)
            }

        }, 2500)
    }


}

export default caruselGallery;